var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinCompaniesScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.linkedin{fill:url(#linkedin-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkedin-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#95d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28434,
    stopColor: "#4495cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#0a66c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b3990"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "linkedin",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M52.14589,34.42377v-4.3104c0-.80003-.64855-1.44858-1.44858-1.44858h-18.39676c-.80003,0-1.44858.64855-1.44858,1.44858v39.77326c0,.80003.64855,1.44858,1.44858,1.44858h18.39676c.80003,0,1.44858-.64855,1.44858-1.44858v-4.3104c0-.80003-.64855-1.44858-1.44858-1.44858h-8.29895c-.80003,0-1.44858-.64855-1.44858-1.44858v-.02642c0-.80003.64855-1.44858,1.44858-1.44858h8.29895c.80003,0,1.44858-.64855,1.44858-1.44858v-2.62318c0-.80003-.64855-1.44858-1.44858-1.44858h-8.29895c-.80003,0-1.44858-.64855-1.44858-1.44858v-.02642c0-.80003.64855-1.44858,1.44858-1.44858h8.29895c.80003,0,1.44858-.64855,1.44858-1.44858v-2.62318c0-.80003-.64855-1.44858-1.44858-1.44858h-8.29895c-.80003,0-1.44858-.64855-1.44858-1.44858v-.02642c0-.80003.64855-1.44858,1.44858-1.44858h8.29895c.80003,0,1.44858-.64855,1.44858-1.44858v-2.62318c0-.80003-.64855-1.44858-1.44858-1.44858h-8.29895c-.80003,0-1.44858-.64855-1.44858-1.44858v-.02642c0-.80003.64855-1.44858,1.44858-1.44858h8.29895c.80003,0,1.44858-.64855,1.44858-1.44858Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M63.54998,64.97507v-.02642c0-.80003.64855-1.44858,1.44858-1.44858h2.7009c.80003,0,1.44858-.64855,1.44858-1.44858v-2.62311c0-.80003-.64855-1.44858-1.44858-1.44858h-2.7009c-.80003,0-1.44858-.64855-1.44858-1.44858v-.02649c0-.80003.64855-1.44858,1.44858-1.44858h2.7009c.80003,0,1.44858-.64855,1.44858-1.44858v-2.62311c0-.80003-.64855-1.44858-1.44858-1.44858h-2.7009c-.80003,0-1.44858-.64855-1.44858-1.44858v-.02649c0-.80003.64855-1.44858,1.44858-1.44858h2.7009c.80003,0,1.44858-.64855,1.44858-1.44858v-1.56289c0-.5538-.31575-1.05914-.81349-1.30194l-10.63852-5.18951c-.96227-.4694-2.08367.23129-2.08367,1.30194v31.47535c0,.80003.64855,1.44858,1.44858,1.44858h10.63852c.80003,0,1.44858-.64855,1.44858-1.44858v-2.01441c0-.80003-.64855-1.44858-1.44858-1.44858h-2.7009c-.80003,0-1.44858-.64855-1.44858-1.44858Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinCompaniesScraper);
export default __webpack_public_path__ + "static/media/linkedin-companies-scraper.bf300c47858966c316c5e91aefdda8f5.svg";
export { ForwardRef as ReactComponent };